/** @module */

export const preamble = `
package org.ligerbots.game_robot;

public class Main {
  public static void main(String[] args) {
    /* Create a new Robot object */
    Robot robot = new Robot();

    /** ======== Start of User Entered Commands ======== */`

export const postamble = `
    /** ======== End of User Entered Commands ======== */

    robot.executeCommands();
  }
}`

export const source = `
/* Add your robot commands here */

/* Move to game piece */
robot.addMoveCommand(/* steps */ 10, /* direction */ "forward");

/* Pickup game piece */
robot.addPickupCommand();

/* Turn left to face target */
robot.addTurnCommand(/* direction */ "left");
robot.addTurnCommand(/* angle */ 40);
robot.addTurnCommand(/* angle */ 50);


/* Move to Target */
robot.addMoveCommand(/* steps */ 15);

/* Shoot game piece at target */
robot.addShootCommand(/* angle */ 46.9, /* power */ 78);
  `
  .replace(/^[ \t]+/gm, '')
  .trim()
